import { render, staticRenderFns } from "./modify-organize.vue?vue&type=template&id=a6f62332&scoped=true"
import script from "./modify-organize.vue?vue&type=script&lang=ts"
export * from "./modify-organize.vue?vue&type=script&lang=ts"
import style0 from "./modify-organize.vue?vue&type=style&index=0&id=a6f62332&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f62332",
  null
  
)

export default component.exports